import Reveal from "./Reveal";
import { cn } from "../lib/utils";

const SectionHeader = ({ index, eyebrow, title, description, align = "center", compact = false }) => {
  return (
    <Reveal
      className={cn(
        compact ? "mb-5 md:mb-6 space-y-2" : "mb-8 md:mb-12 space-y-4",
        align === "center" && "text-center",
      )}
    >
      <div className={cn("flex", align === "center" && "justify-center")}>
        <span
          className={cn(
            "inline-flex items-center gap-2.5 rounded-full border border-primary/35 bg-primary/10 px-4 py-1.5 font-mono font-semibold text-primary shadow-sm shadow-primary/10",
            compact && "px-3 py-1 text-[11px]",
          )}
        >
          <span className="font-bold">{index}</span>
          <span className="h-3.5 w-px bg-primary/40" />
          <span className="uppercase tracking-[0.22em]">{eyebrow}</span>
        </span>
      </div>
      <h2
        className={cn(
          "font-display font-bold tracking-tight text-foreground",
          compact
            ? "text-2xl md:text-3xl lg:text-4xl"
            : "text-3xl md:text-4xl lg:text-5xl",
        )}
      >
        {title}
      </h2>
      {description && (
        <p
          className={cn(
            "text-muted-foreground leading-relaxed max-w-2xl",
            compact ? "text-sm md:text-base" : "text-base md:text-lg",
            align === "center" && "mx-auto",
          )}
        >
          {description}
        </p>
      )}
    </Reveal>
  );
};

export default SectionHeader;